import { AddRelacionClienteInmobiliarioInmueble } from './AddRelacionClienteInmobiliario';
import type { DetailClienteInmuebleModel, EditRelacionClienteInmobiliarioInmuebleModel } from '@api/api';

export class EditRelacionClienteInmobiliarioInmueble implements EditRelacionClienteInmobiliarioInmuebleModel {

    Id: string = null!;
    FechaInicio: Date | null = null;
    FechaFin: Date | null = null;

    constructor(data?: Partial<AddRelacionClienteInmobiliarioInmueble>) {
        if (data) {
            this.FechaInicio = data.FechaInicio ?? null;
            this.FechaFin = data.FechaFin ?? null;
        }
    }

    createFromDetailRelacionClienteInmobiliario(detailRelacionClienteInmobiliario: DetailClienteInmuebleModel): EditRelacionClienteInmobiliarioInmueble {
        Object.assign(this, detailRelacionClienteInmobiliario);
        return this;
    }
} 